import React, { useRef } from 'react';
import CodeHighlight from './../../components/code-highlight/code-highlight.jsx';
import useTemplateInteractions from './../../composables/templateInteractions.js';

function UIMediaObject() {
	const rootRef = useRef(null);
	useTemplateInteractions(rootRef);

	return (
		<div ref={rootRef}>
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-xl-10">
						<div className="row">
							<div className="col-xl-9">
								<ul className="breadcrumb">
									<li className="breadcrumb-item">
										<a href="#/">{'UI Elements'}</a>
									</li>
									<li className="breadcrumb-item active"></li>
								</ul>
								<h1 className="page-header">
									{' Media Object '}
									<small>{'page header description goes here...'}</small>
								</h1>
								<hr className="mb-4" />
								<div id="mediaObject" className="mb-5">
									<h4>{'Media Object'}</h4>
									<p>
										{
											' Recreate the Bootstrap 4 media object easily with flex utilities for greater flexibility and customization. Please read the '
										}
										<a
											href="https://getbootstrap.com/docs/5.3/utilities/flex/#media-object"
											target="_blank" rel="noreferrer"
										>
											{'official Bootstrap documentation'}
										</a>
										{' for the full list of options. '}
									</p>
									<div className="card">
										<div className="card-body p-0">
											<div className="d-flex p-3">
												<a className="w-60px" href="#/">
													<img
														src="https://placehold.co/120x120/dee2e6/161a1d"
														alt=""
														className="mw-100 rounded"
													/>
												</a>
												<div className="ps-3 flex-1">
													<h5 className="mb-1">{'Media heading'}</h5>
													<p className="mb-0">
														{
															'Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin commodo. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla.'
														}
													</p>
												</div>
											</div>
											<hr className="m-0" />
											<div className="d-flex p-3 pe-0">
												<a className="w-60px" href="#/">
													<img
														src="https://placehold.co/120x120/dee2e6/161a1d"
														alt=""
														className="mw-100 rounded"
													/>
												</a>
												<div className="ps-3 flex-1">
													<h5 className="mb-1">{'Media heading'}</h5>
													<p>
														{
															'Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin commodo. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla.'
														}
													</p>
													<hr className="m-0" />
													<div className="d-flex p-3 pb-0">
														<a className="w-60px" href="#/">
															<img
																src="https://placehold.co/120x120/dee2e6/161a1d"
																alt=""
																className="mw-100 rounded"
															/>
														</a>
														<div className="ps-3 flex-1">
															<h5 className="mb-1">{'Nested media heading'}</h5>
															<p className="mb-0">
																{
																	'Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin commodo. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla.'
																}
															</p>
														</div>
													</div>
												</div>
											</div>
											<hr className="m-0" />
											<div className="d-flex p-3">
												<a className="w-60px" href="#/">
													<img
														src="https://placehold.co/120x120/dee2e6/161a1d"
														alt=""
														className="mw-100 rounded"
													/>
												</a>
												<div className="ps-3 flex-1">
													<h5 className="mb-1">{'Media heading'}</h5>
													<p className="mb-0">
														{
															'Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin commodo. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla.'
														}
													</p>
												</div>
											</div>
											<hr className="m-0" />
											<div className="d-flex p-3">
												<a className="w-60px" href="#/">
													<img
														src="https://placehold.co/120x120/dee2e6/161a1d"
														alt=""
														className="mw-100 rounded"
													/>
												</a>
												<div className="ps-3 flex-1">
													<h5 className="mb-1">{'Media heading'}</h5>
													<p className="mb-0">
														{
															'Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin commodo. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla.'
														}
													</p>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-media-object/code-1.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="mediaList" className="mb-5">
									<h4>{'Media List'}</h4>
									<p>
										{
											' The media list displays multiple media objects stacked vertically, creating a list-style presentation. Each item has its own media element and accompanying content, making it ideal for activity feeds, comment sections, or message lists. '
										}
									</p>
									<div className="card">
										<div className="card-body p-0">
											<div className="d-flex p-3 pe-0">
												<a className="w-60px" href="#/">
													<img
														src="https://placehold.co/120x120/dee2e6/161a1d"
														alt=""
														className="mw-100 rounded-pill"
													/>
												</a>
												<div className="flex-1 ps-3">
													<h5 className="mb-1">{'Media heading'}</h5>
													<p>
														{
															'Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin commodo. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis.'
														}
													</p>
													<hr className="m-0" />
													<div className="d-flex p-3 pe-0">
														<a className="w-60px" href="#/">
															<img
																src="https://placehold.co/120x120/dee2e6/161a1d"
																alt=""
																className="mw-100 rounded-pill"
															/>
														</a>
														<div className="flex-1 ps-3">
															<h5 className="mb-1">{'Nested media heading'}</h5>
															<p>
																{
																	'Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin commodo. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis.'
																}
															</p>
															<hr className="m-0" />
															<div className="d-flex p-3 pb-0">
																<a className="w-60px" href="#/">
																	<img
																		src="https://placehold.co/120x120/dee2e6/161a1d"
																		alt=""
																		className="mw-100 rounded-pill"
																	/>
																</a>
																<div className="flex-1 ps-3">
																	<h5 className="mb-1">{'Nested media heading'}</h5>
																	<p className="mb-0">
																		{
																			'Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin commodo. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis.'
																		}
																	</p>
																</div>
															</div>
														</div>
													</div>
													<hr className="m-0" />
													<div className="d-flex p-3 pb-0">
														<a className="w-60px" href="#/">
															<img
																src="https://placehold.co/120x120/dee2e6/161a1d"
																alt=""
																className="mw-100 rounded-pill"
															/>
														</a>
														<div className="flex-1 ps-3">
															<h5 className="mb-1">{'Nested media heading'}</h5>
															<p className="mb-0">
																{
																	'Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin commodo. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis.'
																}
															</p>
														</div>
													</div>
												</div>
											</div>
											<hr className="m-0" />
											<div className="d-flex p-3">
												<div className="flex-1 pe-3">
													<h5 className="mb-1">{'Media heading'}</h5>
													<p className="mb-0">
														{
															'Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin commodo. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis.'
														}
													</p>
												</div>
												<a className="w-60px" href="#/">
													<img
														src="https://placehold.co/120x120/dee2e6/161a1d"
														alt=""
														className="mw-100 rounded-pill"
													/>
												</a>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-media-object/code-2.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="mediaObjectSizes" className="mb-5">
									<h4>{'Media Object Sizes'}</h4>
									<p>
										{
											' Media objects support flexible sizing by adjusting the dimensions of the image or icon. This allows you to create a visual hierarchy—for example, using larger images for primary items and smaller thumbnails for secondary details. '
										}
									</p>
									<div className="card">
										<div className="card-body p-0">
											<div className="d-flex p-3 align-items-center">
												<a className="w-lg-250px w-100px" href="#/">
													<img
														src="https://placehold.co/500x360/dee2e6/161a1d"
														alt=""
														className="mw-100"
													/>
												</a>
												<div className="flex-1 ps-3">
													<h5 className="mb-1">{'Media heading'}</h5>
													{
														' Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin commodo. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus. '
													}
												</div>
											</div>
											<hr className="m-0" />
											<div className="d-flex p-3 align-items-center">
												<a className="w-lg-200px w-80px" href="#/">
													<img
														src="https://placehold.co/500x360/dee2e6/161a1d"
														alt=""
														className="mw-100"
													/>
												</a>
												<div className="flex-1 ps-3">
													<h5 className="mb-1">{'Media heading'}</h5>
													{
														' Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin commodo. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus. '
													}
												</div>
											</div>
											<hr className="m-0" />
											<div className="d-flex p-3 align-items-center">
												<a className="w-lg-150px w-60px" href="#/">
													<img
														src="https://placehold.co/500x360/dee2e6/161a1d"
														alt=""
														className="mw-100"
													/>
												</a>
												<div className="flex-1 ps-3">
													<h5 className="mb-1">{'Media heading'}</h5>
													{
														' Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin commodo. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. '
													}
												</div>
											</div>
											<hr className="m-0" />
											<div className="d-flex p-3 align-items-center">
												<a className="w-lg-100px w-40px" href="#/">
													<img
														src="https://placehold.co/500x360/dee2e6/161a1d"
														alt=""
														className="mw-100"
													/>
												</a>
												<div className="flex-1 ps-3">
													<h5 className="mb-1">{'Media heading'}</h5>
													{
														' Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin commodo. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus. '
													}
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-media-object/code-3.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="mediaListWithButton" className="mb-5">
									<h4>{'Media List with Button'}</h4>
									<p>
										{
											' This variation extends the media list by including an action button within each item. It’s useful for interactive lists where users may need to reply, follow, delete, or take another quick action directly from the media object. '
										}
									</p>
									<div className="card">
										<div className="card-body p-0">
											<div className="d-flex p-3">
												<a className="w-60px" href="#/">
													<img
														src="https://placehold.co/120x120/dee2e6/161a1d"
														alt=""
														className="mw-100 rounded-pill"
													/>
												</a>
												<div className="flex-1 ps-3">
													<h5 className="mb-1">{'Media heading'}</h5>
													<p className="mb-2">
														{
															'Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin commodo. Cras purus odio, tempus viverra turpis.'
														}
													</p>
													<div className="d-flex gap-2">
														<a href="#/" className="btn btn-sm btn-danger w-100px">
															{'Reject'}
														</a>
														<a href="#/" className="btn btn-sm btn-default w-100px">
															{'Cancel'}
														</a>
													</div>
												</div>
											</div>
											<hr className="m-0" />
											<div className="d-flex p-3">
												<div className="flex-1 pe-3 text-end">
													<h5 className="mb-1">{'Nested media heading'}</h5>
													<p className="mb-2">
														{
															'Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin commodo. Cras purus odio,  tempus viverra turpis.'
														}
													</p>
													<div className="d-flex justify-content-end gap-2">
														<a href="#/" className="btn btn-sm btn-success w-100px">
															{'Published'}
														</a>
														<a href="#/" className="btn btn-sm btn-default w-100px">
															{'Cancel'}
														</a>
													</div>
												</div>
												<a className="w-60px" href="#/">
													<img
														src="https://placehold.co/120x120/dee2e6/161a1d"
														alt=""
														className="mw-100 rounded-pill"
													/>
												</a>
											</div>
											<hr className="m-0" />
											<div className="d-flex p-3">
												<a className="w-60px" href="#/">
													<img
														src="https://placehold.co/120x120/dee2e6/161a1d"
														alt=""
														className="mw-100 rounded-pill"
													/>
												</a>
												<div className="flex-1 ps-3">
													<h5 className="mb-1">{'Nested media heading'}</h5>
													<p className="mb-2">
														{
															'Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin commodo. Cras purus odio, tempus viverra turpis.'
														}
													</p>
													<div className="d-flex gap-2">
														<a href="#/" className="btn btn-sm btn-primary w-100px">
															{'Confirm'}
														</a>
														<a href="#/" className="btn btn-sm btn-default w-100px">
															{'Cancel'}
														</a>
													</div>
												</div>
											</div>
											<hr className="m-0" />
											<div className="d-flex p-3">
												<div className="flex-1 pe-3 text-end">
													<h5 className="mb-1">{'Nested media heading'}</h5>
													<p className="mb-2">
														{
															'Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin commodo. Cras purus odio,  tempus viverra turpis.'
														}
													</p>
													<div className="d-flex justify-content-end gap-2">
														<a href="#/" className="btn btn-sm btn-warning w-100px">
															{'Edit'}
														</a>
														<a href="#/" className="btn btn-sm btn-default w-100px">
															{'Cancel'}
														</a>
													</div>
												</div>
												<a className="w-60px" href="#/">
													<img
														src="https://placehold.co/120x120/dee2e6/161a1d"
														alt=""
														className="mw-100 rounded-pill"
													/>
												</a>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-media-object/code-4.json"
												/>
											</pre>
										</div>
									</div>
								</div>
							</div>
							<div className="col-xl-3">
								<nav
									data-init="scrollspy"
									className="navbar navbar-sticky navbar-sticky-start d-none d-xl-block py-4 h-100"
								>
									<nav className="nav">
										<a className="nav-link" href="#mediaObject" data-toggle="scroll-to">
											{'Media Object'}
										</a>
										<a className="nav-link" href="#mediaList" data-toggle="scroll-to">
											{'Media List'}
										</a>
										<a className="nav-link" href="#mediaObjectSizes" data-toggle="scroll-to">
											{'Media Object Sizes'}
										</a>
										<a className="nav-link" href="#mediaListWithButton" data-toggle="scroll-to">
											{'Media List with Button'}
										</a>
									</nav>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default UIMediaObject;
